import { render, staticRenderFns } from "./formular.vue?vue&type=template&id=2d2029e0&scoped=true&"
import script from "./formular.vue?vue&type=script&lang=js&"
export * from "./formular.vue?vue&type=script&lang=js&"
import style0 from "./formular.vue?vue&type=style&index=0&id=2d2029e0&prod&lang=css&"
import style1 from "./formular.vue?vue&type=style&index=1&id=2d2029e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2029e0",
  null
  
)

export default component.exports